import { generate, greenDark, presetPalettes, redDark, orangeDark, greyDark } from '@ant-design/colors';
import { useChainedCommands, useActive, useEditorView } from '@remirror/react';
import React, { useCallback, useMemo, useState } from 'react';
import CommandButton from '../CommandButton';
import { ColorPicker, theme } from 'antd';

const { useToken } = theme;

function genPresets(presets = presetPalettes) {
  return Object.entries(presets).map(([label, colors]) => ({ label, colors, key: label }));
}

const getSuggestedColors = (token) => [
  {
    label: 'Suggested',
    colors: [token.colorText, '#2E86C1', '#27AE60', '#E74C3C', '#F39C12', '#8E44AD', '#7F8C8D'],
  },
];

export function TextColorButton() {
  const active = useActive();
  const { token } = useToken();
  const commands = useChainedCommands();
  const [open, setOpen] = useState(false);
  const selection = useEditorView()?.state?.selection;

  const handleColorClick = useCallback(
    (factory) => {
      const color = factory?.metaColor?.toHexString() || token.colorText;
      if (color == token.colorText) {
        commands.focus().removeTextColor().run();
      } else {
        commands.setTextColor(color).focus().run();
      }
    },
    [setOpen]
  );

  const presets = useMemo(() => {
    let _presets = genPresets({
      primary: generate(token.colorPrimary),
      red: redDark,
      green: greenDark,
      orange: orangeDark,
      grey: greyDark,
    });
    return [...getSuggestedColors(token), ..._presets];
  }, [token.colorPrimary]);

  const activeColor = useMemo(() => {
    let color = token.colorText;
    Object.entries(presets).map(([_, { colors }]) => {
      colors?.forEach((value) => {
        if (typeof value !== 'string') value = value?.metaColor?.toHexString();
        if (active.textColor({ color: String(value).toLowerCase() })) color = value;
      });
    });
    return color;
  }, [selection]);

  return (
    <>
      <CommandButton enabled={true}>
        <ColorPicker
          rootClassName="cms__color__picker"
          showText={false}
          disabledAlpha={true}
          disabledFormat={true}
          arrow={false}
          presets={presets}
          size={'small'}
          value={activeColor}
          open={open}
          onOpenChange={setOpen}
          panelRender={(_, { components }) => {
            const { Presets } = components;
            return <Presets />;
          }}
          onChange={handleColorClick}
        />
      </CommandButton>
    </>
  );
}

export default React.memo(TextColorButton);
